/* eslint-disable */

/**
 * ATTENTION:
 *
 * This file is overwritten by the backend build, original template is located in:
 * `\Configuration\templates\Presentation\SOLO.Presentation.Client\src\build\env.js`
 */
export default {
    sso_url: 'https://ssobeta.snapon.com/Login.aspx?ReturnUrl=https://solobeta.snapon.com',
    no_image_url: 'https://Public.Snapon.com/R_RRD/Objects_lg/images/NoImageRequired_Slug.jpg',
    web_reports_url: 'https://webreportsbeta.snapon.com',
    sales_reports_url: 'https://tableau-test.snapon.com/#/views/SoloReport/SOLODashboard',
    sso: {
        isUsingOldSSO: false,
        clientId: 'Solo.js',
        authRoot: 'https://loginbeta.snapon.com',
        webRoot: 'https://solobeta.snapon.com',
        scope: 'openid profile SoloApi'
    },
    googleTagManagerContainerId: 'GTM-W5ZGLGV'
};



// WEBPACK FOOTER //
// ./src/config/env.js